import { createSelectors } from "@/redux/helpers/selector";

import { MODULE } from "./constants";

export const [
  getIsOpen,
  getMode,
  getActiveEntry,
  getActiveOrder,
  getActiveEvent,
  getBlockDraftIncomplete,
  getPendingBlock,
  getOrderDetails,
  getIsFetchingOrderDetails,
] = createSelectors(MODULE, [
  "isOpen",
  "mode",
  "activeEntry",
  "activeOrder",
  "activeEvent",
  "blockDraftIncomplete",
  "pendingBlock",
  "orderDetails",
  "isFetchingOrderDetails",
]);
